module.exports = __webpack_public_path__ + "fonts/cges-icons.656aa2da.woff";